export default __webpack_public_path__ + "static/media/piano-performance.1e73799a.jpg";